import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import {
  makeStripeConnectedAccountFormLink,
} from 'common/stripeHelpers';

import SrCard, {
  SR_CARD_FONT_SIZE_SMALL,
} from 'client/components/SrCard/SrCard';
import SrButton, {
  SR_BUTTON_HEIGHT_TALL,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrLabel from 'client/components/SrLabel/SrLabel';
import SrPartnerBankAccountInviteModal from './SrPartnerBankAccountInviteModal';

const SrPartnerBankAccountNew = ({
  listing,
  partner,
}) => {
  const history = useHistory();
  const [partnerBankAccountInviteModalIsOpen, setPartnerBankAccountInviteModalIsOpen] = useState(false);

  const connectBankAccountUrl = makeStripeConnectedAccountFormLink({
    listingId: listing?.id,
    partnerId: partner?.id,
  });

  return (
    <>
      <SrCard
        headerSizeType={SR_CARD_FONT_SIZE_SMALL}
        header='Add collection method'
      >
        <SrBox marginTop='21px'>
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_GREEN}
            heightType={SR_BUTTON_HEIGHT_TALL}
            hasBoxShadow
            type='button'
            onClick={() => history.push(connectBankAccountUrl)}
          >
            Connect Debit or Bank
          </SrButton>
          <SrBox margin='33px 30%'>
            <SrFlex align='center' justify='center'>
              <SrBox width='100%' height='1px' backgroundColor='rgba(123, 132, 136, 0.16)' />
              <SrBox margin='0 14px'>
                <SrText
                  color='grey400'
                  font='greycliff'
                  fontSize='13px'
                  lineHeight='16px'
                  weight='600'
                  align='center'
                  letterSpacing='0.41px'
                >
                  or
                </SrText>
              </SrBox>
              <SrBox width='100%' height='1px' backgroundColor='rgba(123, 132, 136, 0.16)' />
            </SrFlex>
          </SrBox>
          <SrLabel
            alignCenter
            justifyCenter
            label='Invite Client to Collect'
            color='blue300'
            borderColor='#007AFF'
            onClick={() => setPartnerBankAccountInviteModalIsOpen(true)}
          />
        </SrBox>
      </SrCard>

      {partnerBankAccountInviteModalIsOpen && (
        <SrPartnerBankAccountInviteModal
          listing={listing}
          partner={partner}
          onClose={() => {
            setPartnerBankAccountInviteModalIsOpen(false);
          }}
        />
      )}
    </>
  );
};

SrPartnerBankAccountNew.propTypes = {
  listing: PropTypes.object,
  partner: PropTypes.object,
};

SrPartnerBankAccountNew.displayName = 'SrPartnerBankAccountNew';

export default SrPartnerBankAccountNew;
